/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-11 19:21:09
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-13 01:52:59
 */

import SrmPage from '../login/login'    // 登录

/** home */
import TabPage from '../home/tabPage'
import Home from '../home/Home'
//import Message from '../home/Message'
import Message from '../imManage/SrmIMManage.vue'
import Mine from '../home/mine'
import ApprovalTab from '../pendingApproval/ApprovalTab.vue'
/** quote */
import QuoteList from '../quote/quoteList'
import Alex from '../quote/alex'
import Quote from '../quote/quote'
/** order */
import OrderComfirm from '../order/orderComfirm'
import Order from '../order/order'
/** auction */
import AuctionList from '../auction/auctionList'
/** delivery */
import DeliveryList from '../delivery/deliveryList'
import NoticeList from '../delivery/noticeList'
import Delivery from '../delivery/delivery'
import Notice from '../delivery/notice'

/** 合同审批详情与合同浏览共用同一懒加载函数，保证路由切换复用同一组件定义 */
const loadCctContractItemPage = () =>
  import(/* webpackChunkName: 'delivery' */ '../pendingApproval/CctContractItemDetail.vue')

let router = [

  {
    path: '/Alex',
    name: 'Alex',
    component: () => import(/* webpackChunkName: 'quote' */ '@/page/srm/quote/alex'),
    backPath: ''
  },
  {
    path: '/srmLogin',
    name: 'srmLogin',
    component: () => import(/* webpackChunkName: 'srmPage' */ '@/page/srm/login/login'),
    backPath: ''
  },
  // 飞书免登录回调页面
  {
    path: '/feishuToken',
    name: 'feishuToken',
    component: () => import(/* webpackChunkName: 'feishu' */ '@/page/srm/feishu/feishuToken'),
    backPath: ''
  },
  // 顶级 /mine 重定向，用于微信 OAuth 回调直接跳转到 mine 页面，保留 query 参数
  {
    path: '/mine',
    redirect: (to) => {
      const query = to.query || {}
      return { name: 'mine', query: query }
    }
  },
  {
    path: '/TabPage',
    name: 'TabPage',
    component: TabPage,
    backPath: '',
    children: [
      {
        path: '/',
        redirect: {name: 'home'},
        backPath: ''
      },
      {
        path: '/home',
        name: 'home',
        component: Home,
        backPath: ''
      },
      {
        path: '/message',
        name: 'message',
        component: Message,
        backPath: ''
      },
      {
        path: '/approval',
        name: 'approval',
        component: ApprovalTab,
        backPath: ''
      },
      {
        path: '/mine',
        name: 'mine',
        component: Mine,
        backPath: ''
      }
    ]
  },
  {
    path: '/SupplierArchiveView',
    name: 'SupplierArchiveView',
    component: () => import(/* webpackChunkName: 'supplierArchive' */ '@/page/srm/demo/SupplierArchiveView'),
    backPath: ''
  },
  {
    path: '/Performance',
    name: 'Performance',
    component: () => import(/* webpackChunkName: 'performance' */ '../spe/performance/spePerformanceList.vue'),
    backPath: ''
  },
  {
    path: '/SpePerformanceDetail',
    name: 'SpePerformanceDetail',
    component: () => import(/* webpackChunkName: 'performance' */ '../spe/performance/spePerformanceDetail.vue'),
    backPath: '/Performance'
  },
  {
    path: '/OnSiteEvaluationHub',
    name: 'OnSiteEvaluationHub',
    redirect: '/LocaleInspectList',
    backPath: ''
  },
  {
    path: '/LocaleInspectList',
    name: 'LocaleInspectList',
    component: () => import(/* webpackChunkName: 'home' */ '@/page/srm/home/modules/LocaleInspectList.vue'),
    backPath: ''
  },
  {
    path: '/LocaleInspectScore',
    name: 'LocaleInspectScore',
    component: () => import(/* webpackChunkName: 'home' */ '@/page/srm/home/modules/LocaleInspectScore.vue'),
    backPath: ''
  },
  {
    path: '/MaterialArrivalPlanHub',
    name: 'MaterialArrivalPlanHub',
    component: () => import(/* webpackChunkName: 'home' */ '@/page/srm/home/modules/MaterialArrivalPlanHub.vue'),
    backPath: ''
  },
  {
    path: '/StatementOfAccountHub',
    name: 'StatementOfAccountHub',
    component: () => import(/* webpackChunkName: 'home' */ '@/page/srm/home/modules/StatementOfAccountHub.vue'),
    backPath: ''
  },
  {
    path: '/AccountStmtList',
    name: 'AccountStmtList',
    component: () => import(/* webpackChunkName: 'accountStmt' */ '../rcn/accountStmt/accountStmtList.vue'),
    backPath: ''
  },
  {
    path: '/AccountStmtDetail',
    name: 'AccountStmtDetail',
    component: () => import(/* webpackChunkName: 'accountStmt' */ '../rcn/accountStmt/accountStmtDetail.vue'),
    backPath: '/AccountStmtList'
  },
  {
    path: '/PurDeliveryNoticeList',
    name: 'PurDeliveryNoticeList',
    component: () => import(/* webpackChunkName: 'deliveryNotice' */ '@/page/srm/pur/deliveryNotice/purDeliveryNoticeList.vue'),
    backPath: ''
  },
  {
    path: '/PurDeliveryNoticeEdit',
    name: 'PurDeliveryNoticeEdit',
    component: () => import(/* webpackChunkName: 'deliveryNotice' */ '@/page/srm/pur/deliveryNotice/purDeliveryNoticeEdit.vue'),
    backPath: '/PurDeliveryNoticeList'
  },
  {
    path: '/SupplierDeliveryNoticeList',
    name: 'SupplierDeliveryNoticeList',
    component: () => import(/* webpackChunkName: 'deliveryNotice' */ '@/page/srm/pur/deliveryNotice/supplierDeliveryNoticeList.vue'),
    backPath: ''
  },
  {
    path: '/SupplierDeliveryNoticeDetail',
    name: 'SupplierDeliveryNoticeDetail',
    component: () => import(/* webpackChunkName: 'deliveryNotice' */ '@/page/srm/pur/deliveryNotice/supplierDeliveryNoticeDetail.vue'),
    backPath: '/SupplierDeliveryNoticeList'
  },
  {
    path: '/QuoteList',
    name: 'QuoteList',
    component: () => import(/* webpackChunkName: 'quote' */ '@/page/srm/quote/quoteList'),
    backPath: ''
  },
  {
    path: '/Quote',
    name: 'Quote',
    component: () => import(/* webpackChunkName: 'quote' */ '@/page/srm/quote/quote'),
    backPath: ''
  },
  {
    path: '/AuctionList',
    name: 'AuctionList',
    component: () => import(/* webpackChunkName: 'auction' */ '@/page/srm/auction/auctionList'),
    backPath: ''
  },
  {
    path: '/OrderComfirm',
    name: 'OrderComfirm',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/orderComfirm'),
    backPath: ''
  },
  {
    path: '/OrderSearch',
    redirect: '/PurOrderList',
  },
  {
    path: '/PurOrderList',
    name: 'PurOrderList',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/purOrderList'),
    backPath: ''
  },
  {
    path: '/PurOrderDetail',
    name: 'PurOrderDetail',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/purOrderDetail'),
    backPath: '/PurOrderList'
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/order'),
    backPath: ''
  },
  {
    path: '/SupplierPurOrderList',
    name: 'SupplierPurOrderList',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/supplierPurOrderList'),
    backPath: ''
  },
  {
    path: '/SupplierPurOrderDetail',
    name: 'SupplierPurOrderDetail',
    component: () => import(/* webpackChunkName: 'order' */ '@/page/srm/order/supplierPurOrderDetail'),
    backPath: '/SupplierPurOrderList'
  },
  {
    path: '/SupplierInquiryList',
    name: 'SupplierInquiryList',
    component: () => import(/* webpackChunkName: 'inquiry' */ '../inquiry/supplierInquiryList.vue'),
    backPath: ''
  },
  {
    path: '/SupplierInquiryView',
    name: 'SupplierInquiryView',
    component: () => import(/* webpackChunkName: 'inquiry' */ '../inquiry/supplierInquiryView.vue'),
    backPath: '/SupplierInquiryList'
  },
  {
    path: '/SupplierInquiryQuote',
    name: 'SupplierInquiryQuote',
    component: () => import(/* webpackChunkName: 'inquiry' */ '../inquiry/supplierInquiryQuote.vue'),
    backPath: '/SupplierInquiryList'
  },
  {
    path: '/DeliveryList',
    name: 'DeliveryList',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/deliveryList'),
    backPath: ''
  },
  {
    path: '/NoticeList',
    name: 'NoticeList',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/noticeList'),
    backPath: ''
  },
  {
    path: '/Delivery',
    name: 'Delivery',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/delivery'),
    backPath: ''
  },
  {
    path: '/ScanBindDeliveryNote',
    name: 'ScanBindDeliveryNote',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/scanBindDeliveryNote'),
    backPath: ''
  },
  {
    path: '/Notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/delivery/notice'),
    backPath: ''
  },
  {
    path: '/biddingList',
    name: 'biddingList',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/sfd/biddingList.vue')
  },
  {
    path: '/biddingParticulars',
    name: 'biddingParticulars',
    component: () => import(/* webpackChunkName: 'delivery' */ '@/page/srm/sfd/biddingParticulars.vue')
  },
  {
    path: '/noticeDetailView',
    name: 'noticeDetailView',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/NoticeDetailView.vue')
  },
  {
    path: '/baseNoticeList',
    name: 'baseNoticeList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/NoticeList.vue')
  },
  {
    // 到货验收单列表
    path: '/receiveAcceptList',
    name: 'receiveAcceptList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/receiveAccept/ReceiveAcceptList.vue')
  },
  {
    // 到货验收单详情
    path: '/receiveAcceptDetail',
    name: 'receiveAcceptDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/receiveAccept/ReceiveAcceptDetail.vue')
  },
  {
    // 安装调试收单列表
    path: '/installAcceptList',
    name: 'installAcceptList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/installAccept/InstallAcceptList.vue')
  },
  {
    // 安装调试单详情
    path: '/installAcceptDetail',
    name: 'installAcceptDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../cct/installAccept/InstallAcceptDetail.vue')
  },
  {
    // 资质审查列表
    path: '/qualifyCensorList',
    name: 'qualifyCensorList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/qualifyCensor/QualifyCensorList.vue')
  },
  {
    // 供应商冻结/解冻列表
    path: '/dailyManageList',
    name: 'dailyManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/dailyManage/DailyManageList.vue')
  },
  {
    // 供应商冻结/解冻详情
    path: '/dailyManageDetail',
    name: 'dailyManageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/dailyManage/DailyManageDetail.vue')
  },
  {
    // 供应商黑名单列表
    path: '/blacklistManageList',
    name: 'blacklistManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/blacklistManage/BlacklistManageList.vue')
  },
  {
    // 供应商黑名单详情
    path: '/blacklistManageDetail',
    name: 'blacklistManageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/blacklistManage/BlacklistManageDetail.vue')
  },
  {
    // 供应商注册审批列表
    path: '/supplierRegisterApproveList',
    name: 'supplierRegisterApproveList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierRegister/SupplierRegisterApproveList.vue')
  },
  {
    // 供应商注册领导审批列表
    path: '/supplierRegisterApproveManageList',
    name: 'supplierRegisterApproveManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierRegister/SupplierRegisterApproveManageList.vue')
  },
  {
    // 供应商变更审批列表
    path: '/supplierChangeManageList',
    name: 'supplierChangeManageList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierChange/SupplierChangeManageList.vue')
  },
  {
    // 供应商变更审批详情
    path: '/supplierChangeManageDetail',
    name: 'supplierChangeManageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../slc/supplierChange/SupplierChangeManageDetail.vue')
  },
  {
    // 招标发布审批列表
    path: '/biddingPublishList',
    name: 'biddingPublishList',
    component: () => import(/* webpackChunkName: 'delivery' */ '../sfd/biddingPublish/BiddingPublishList.vue')
  },
  {
    // 招标发布审批详情
    path: '/biddingPublishDetail',
    name: 'biddingPublishDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../sfd/biddingPublish/BiddingPublishDetail.vue')
  },
  {
    // 下载附件
    path: '/attachmentDownload',
    name: 'attachmentDownload',
    component: () => import(/* webpackChunkName: 'delivery' */ '../../components/AttachmentDownload.vue')
  },
  {
    // IM沟通管理
    path: '/imMessageManage',
    name: 'imMessageManage',
    component: () => import(/* webpackChunkName: 'delivery' */ '../imManage/SrmImMessageManage.vue')
  },
  {
    // 测试扫一扫功能
    path: '/testScan',
    name: 'testScan',
    component: () => import(/* webpackChunkName: 'delivery' */ '../notice/TestScan.vue')
  },
  {
    // 待办流程
    path: '/pendingApproval',
    name: 'pendingApproval',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PendingApprovalList.vue')
  },
  {
    // 价格申请
    path: '/PurPriceApplyOperate',
    name: 'PurPriceApplyOperate',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/purPriceApplyOperate.vue')
  },
  {
    // 询价定价审批（兼容旧路由名）
    path: '/FixedPrice',
    name: 'FixedPrice',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/FixedPriceApproveDetail.vue')
  },
  {
    path: '/FixedPriceApproveDetail',
    name: 'FixedPriceApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/FixedPriceApproveDetail.vue')
  },
  {
    path: '/InquiryNotQuotationDetail',
    name: 'InquiryNotQuotationDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/InquiryNotQuotationDetail.vue')
  },
  {
    path: '/BiddingRespondDetail',
    name: 'BiddingRespondDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/BiddingRespondDetail.vue')
  },
  {
    // 竞价定价审批（兼容旧路由名）
    path: '/Bidding',
    name: 'Bidding',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/CompeteAwardApproveDetail.vue')
  },
  {
    path: '/CompeteAwardApproveDetail',
    name: 'CompeteAwardApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/CompeteAwardApproveDetail.vue')
  },
  {
    // 供应商状态变更（兼容旧路由名）
    path: '/SlcSupplierStatusChange',
    name: 'SlcSupplierStatusChange',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SupplierStatusChangeApproveDetail.vue')
  },
  {
    // 供应商注册审批
    path: '/SupplierRegisterApproveDetail',
    name: 'SupplierRegisterApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SupplierRegisterApproveDetail.vue')
  },
  {
    // 代注册审批
    path: '/InsideRegisterApproveDetail',
    name: 'InsideRegisterApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/InsideRegisterApproveDetail.vue')
  },
  {
    // 供应商资质审查（旧）
    path: '/QualifyCensorDetail',
    name: 'QualifyCensorDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/QualifyCensorDetail.vue')
  },
  {
    // 资质审查审批详情
    path: '/QualificationReviewDetail',
    name: 'QualificationReviewDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/QualificationReviewDetail.vue')
  },
  {
    // 现场考察（旧）
    path: '/LocaleInspect',
    name: 'LocaleInspect',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/LocaleInspect.vue')
  },
  {
    // 现场考察审批详情
    path: '/LocaleInspectDetail',
    name: 'LocaleInspectDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/LocaleInspectDetail.vue')
  },
  {
    // 样品评估审批详情
    path: '/SampleTrialDetail',
    name: 'SampleTrialDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SampleTrialDetail.vue')
  },
  {
    // 合格供应商申请（旧）
    path: '/SlcQualifiedSupplier',
    name: 'SlcQualifiedSupplier',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SlcQualifiedSupplier.vue')
  },
  {
    // 品类转合格审批
    path: '/QualifiedSupplierApproveDetail',
    name: 'QualifiedSupplierApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/QualifiedSupplierApproveDetail.vue')
  },
  {
    // 供应商变更
    path: '/SupplierChangeDetail',
    name: 'SupplierChangeDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SupplierChangeDetail.vue')
  },
  {
    // 附加费用审批
    path: '/AdditionalFeeApproveDetail',
    name: 'AdditionalFeeApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/AdditionalFeeApproveDetail.vue')
  },
  {
    // 价格申请审批
    path: '/PurPriceApplyApproveDetail',
    name: 'PurPriceApplyApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PurPriceApplyApproveDetail.vue')
  },

  {
    // 供应商冻结/解冻（旧）
    path: '/SupplierFreezeDetail',
    name: 'SupplierFreezeDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SupplierFreezeDetail.vue')
  },
  {
    // 供应商冻结/解冻审批
    path: '/SupplierFreezeUnfreezeApproveDetail',
    name: 'SupplierFreezeUnfreezeApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SupplierFreezeUnfreezeApproveDetail.vue')
  },
  {
    // 供应商状态变更审批
    path: '/SupplierStatusChangeApproveDetail',
    name: 'SupplierStatusChangeApproveDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SupplierStatusChangeApproveDetail.vue')
  },
  {
    // 招标发布审批详情
    path: '/BiddingPublishDetail',
    name: 'BiddingPublishDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/BiddingPublishDetail.vue')
  },
  {
    // 定标详情
    path: '/BiddingPicketageDetail',
    name: 'BiddingPicketageDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/BiddingPicketageDetail.vue')
  },
  {
    // 合同模板详情
    path: '/CctHtmbDetail',
    name: 'CctHtmbDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/CctHtmbDetail.vue')
  },

  {
    // 合同用印审批详情
    path: '/CctHtcjDetail',
    name: 'CctHtcjDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/CctHtcjDetail.vue')
  },
  {
    // 采购订单审批详情
    path: '/PurOrderDetail',
    name: 'PurOrderDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PurOrderDetail.vue')
  },
  {
    // 非生收货单审批详情
    path: '/PurConsigneeDetail',
    name: 'PurConsigneeDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PurConsigneeDetail.vue')
  },
  // 非生采购申请审批详情
  {
    path: '/PurApplyDetail',
    name: 'PurApplyDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PurApplyDetail.vue')
  },
  // 8D报告审批详情
  {
    path: '/Qcn8dReportDetail',
    name: 'Qcn8dReportDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/Qcn8dReportDetail.vue')
  },
  // 定损审批详情
  {
    path: '/QcnLossAssessmentDetail',
    name: 'QcnLossAssessmentDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/QcnLossAssessmentDetail.vue')
  },
  // 索赔单审批详情
  {
    path: '/QcnClaimHeaderDetail',
    name: 'QcnClaimHeaderDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/QcnClaimHeaderDetail.vue')
  },
  // 非生结算单审批详情
  {
    path: '/RcnSettlementDetail',
    name: 'RcnSettlementDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/RcnSettlementDetail.vue')
  },
  // 预付款申请审批详情
  {
    path: '/PayRequestYfkDetail',
    name: 'PayRequestYfkDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PayRequestYfkDetail.vue')
  },
  // 到货付款申请审批详情
  {
    path: '/PayRequestDhfkDetail',
    name: 'PayRequestDhfkDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PayRequestDhfkDetail.vue')
  },
  // 非生独立付款申请审批详情
  {
    path: '/PayRequestFsfkDetail',
    name: 'PayRequestFsfkDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/PayRequestFsfkDetail.vue')
  },
  // 模具主数据审批详情
  {
    path: '/MoldMasterDataDetail',
    name: 'MoldMasterDataDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/MoldMasterDataDetail.vue')
  },
  // 模具变更审批详情
  {
    path: '/MoldMouldsChangeDetail',
    name: 'MoldMouldsChangeDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/MoldMouldsChangeDetail.vue')
  },
  // 模具报废审批详情
  {
    path: '/MoldMouldsScrapDetail',
    name: 'MoldMouldsScrapDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/MoldMouldsScrapDetail.vue')
  },
  // 模具验收审批详情
  {
    path: '/MoldMouldsInspectionDetail',
    name: 'MoldMouldsInspectionDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/MoldMouldsInspectionDetail.vue')
  },
  // 合同模板审批详情
  {
    path: '/CctContractTempDetail',
    name: 'CctContractTempDetail',
    component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/CctContractTempDetail.vue')
  },
  // 合同管理审批详情
  {
    path: '/CctContractItemDetail',
    name: 'CctContractItemDetail',
    component: loadCctContractItemPage
  },
  // 合同信息浏览（从关联合同等入口进入，无审批区与审批历史）
  {
    path: '/CctContractItemView',
    name: 'CctContractItemView',
    meta: { viewContractOnly: true },
    component: loadCctContractItemPage
  },
    //绩效评分
    {
        path: '/SrmSpeSchemeScoreEdit',
        name: 'SrmSpeSchemeScoreEdit',
        component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SrmSpeSchemeScoreEdit.vue')
    },
    //绩效汇总
    {
        path: '/SrmSpeSchemeScoreTotalEdit',
        name: 'SrmSpeSchemeScoreTotalEdit',
        component: () => import(/* webpackChunkName: 'delivery' */ '../pendingApproval/SrmSpeSchemeScoreTotalEdit.vue')
    },
]

export default router



// WEBPACK FOOTER //
// ./src/page/srm/config/router.js